import { Routes, Route, Navigate } from "react-router-dom"
import React, { useEffect } from 'react';
import SearchPage from '../components/Searcher/SearchPage';
import ComparatorPage from '../components/Comparator/ComparatorPage';
import FundDetails from '../components/Details/FundDetails';

//hooks
import { useIsComparing } from '../hooks/main/useIsComparing';
import { FundDetailsProvider } from '../context/FundDetailsContext';

function IndexRoutes() {

  const { isComparing, startComparing } = useIsComparing();

  useEffect(() => {
    global.scrollTo(0, 0);
  }, [isComparing]);


  return (
    <div>
      <Routes>
        <Route
          path="/"
          element={
            <SearchPage startComparing={() => startComparing()}/>
          }
        />
        <Route
          path="/id/:productId"
          element={
            <FundDetailsProvider>
              <FundDetails startComparing={() => startComparing()} /> 
            </FundDetailsProvider>
            }
        />
        <Route
          path="/compare/:productId"
          element={
            <ComparatorPage />
          }
        />
        <Route key="not-found" path="*" element={<Navigate to='/' />} />
      </Routes>
    </div>
  )
}

export default IndexRoutes